import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from '../../../assets/images/blog/careers.png'

const GraduateCareers = () => {
    return (
        <>
            <Breadcumb Title="Graduate & Junior Careers" Breadcumb="CAREERS" BgImg={BgImg} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-title">
                                <p className="section-title__text">Start your career</p>
                                <h2 className="section-title__title">Learn from experienced consultants, on real projects</h2>
                            </div>
                            <div className="about-four__text" style={{marginBottom: 20}}>
                                Every senior consultant was a junior once. At BEET Technologies we take early-career
                                development seriously: our internships and junior roles are designed to turn promising
                                graduates into confident professionals, with real responsibility from the very first
                                weeks — never a year of shadowing and coffee runs.
                            </div>
                            <div className="about-four__text" style={{marginBottom: 30}}>
                                We welcome graduates and juniors across engineering, design, and agile delivery, in all
                                three of our hubs — Wolverhampton (UK), Malmö (Sweden), and Accra (Ghana).
                            </div>
                            <ul className="service-details__caption__list" style={{marginBottom: 40}}>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    A dedicated mentor from day one — a senior consultant invested in your growth
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Real client work from your first weeks, with support to succeed
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    A structured learning path with time set aside for study and certification
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    A clear route from intern to junior to mid-level — many of our consultants started here
                                </li>
                            </ul>
                            <Link to="/careers" className="thm-btn"><span>View Open Roles</span></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GraduateCareers
